import { localizeDate } from '@/utils/date';
import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import { connectorLogsSearchQueryMixin } from '@/mixins/connectorLogsSearchQuery';
export default {
  name: 'CoreConnectorsPacketLogs',
  mixins: [connectorLogsSearchQueryMixin],
  props: {
    connectorId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      isLoadingLogs: false,
      connectorLogs: [],
      logItemPayload: null,
      activeItemId: null,
      lastRefreshed: null
    };
  },
  computed: {
    ...mapState('app', ['color']),
    hasNoPackets() {
      return this.connectorLogs.length === 0;
    }
  },
  mounted() {
    this.fetchConnectorLogs();
  },
  methods: {
    localizeDate,
    copySuccess() {
      this.$snack(this.$i18n_t('Common.copyToClipboardSuccess'), 'success');
    },
    isJsonPayload(payload) {
      try {
        JSON.parse(JSON.stringify(payload));
      } catch (e) {
        return false;
      }
      return true;
    },
    handleItemSelected(item) {
      this.activeItemId = item.id;
      this.logItemPayload = item.payload;
    },
    fetchConnectorLogs() {
      this.isLoadingLogs = true;
      this.logItemPayload = null;
      ApiService.getBridgeTraffic(this.connectorId, true).then(response => {
        this.lastRefreshed = new Date();
        this.connectorLogs = response;
        if (this.filteredConnectorLogs.length > 0) {
          this.handleItemSelected(this.filteredConnectorLogs[0]);
        }
      }).catch(error => {
        this.$snack(this.$i18n_t('Connectors.Connectors.packetLogs.error'), 'error');
        console.error(error);
      }).finally(() => {
        this.isLoadingLogs = false;
      });
    }
  }
};